'use client'

import { useMemo, useState } from 'react'

import { Skeleton } from '@nextui-org/react'
import { usePathname, useRouter, useSearchParams } from 'next/navigation'

import TitleMarquee from '@/components/layouts/Header/components/TitleMarquee'
import ExperienceSidebar from '@/components/layouts/SideBar/ExperienceSidebar'
import TabSlider from '@/components/shared/TabSlider'
import { useGetBannerQuery } from '@/redux/api/banner'
import ClientOnly from '@/components/shared/ClientOnly'
import { useGetLeaderboardReferralQuery } from '@/redux/api/wallet/wallet.apiw3'
import { cn } from '@/utils/cn'

import styles from './styles.module.css'
import PostAddMB from './components/PostAddMB'
import PostTextarea from '../post-cre/components/RenderFormFeed'
import { ListTrending } from './components/ListPost/Trending'
import { ListFollowing } from './components/ListPost/Following'
import { ListPost } from './components/ListPost/Posts'

const tabs = [
  {
    key: 'posts',
    value: 'Posts',
  },
  {
    key: 'trending',
    value: 'Trending',
  },
  {
    key: 'following',
    value: 'Following',
  },
]
const FeedPage = () => {
  const searchParams = useSearchParams()
  const getParamsShareId = searchParams.get('shareID')
  const pathname = usePathname()
  const router = useRouter()
  const [activeTab, setActiveTab] = useState<number>(0)

  const { data: banner, isLoading: isLoadingBanner } = useGetBannerQuery({ key: 'POPUP_HEADER' })

  const { data, isLoading } = useGetLeaderboardReferralQuery({
    page: 0,
    limit: 10,
    // sort: 'ASC',
    dateFrom: undefined,
    dateTo: undefined,
  })

  const getLeaderboard = useMemo(() => {
    if (!data?.data) return []
    const getTopRank = data?.data.filter((i) => i.userRank === 1 || i.userRank === 2 || i.userRank === 3)
    return getTopRank
  }, [data])

  return (
    <ClientOnly
      fallback={
        <Skeleton>
          <div className="h-[447px] rounded-lg bg-default-300"></div>
        </Skeleton>
      }
    >
      {/*<ConnectKitButton />*/}
      <div className="top-0 z-[40] w-full overflow-hidden border-b-white/10 bg-ss-dark lg:sticky lg:z-[49] lg:border-b">
        <TitleMarquee>
          {!isLoading || !isLoadingBanner ? (
            // Show leaderboard if banner empty
            banner?.length ? (
              <div className="flex items-center gap-x-[10rem]">
                {banner.map(({ description }: { description: string }, i: number) => (
                  <p key={i}>{description}</p>
                ))}
              </div>
            ) : getLeaderboard?.length ? (
              getLeaderboard.map(({ userId, userRank, nickname, totalPoints }) => (
                <div key={userId} className="flex items-center gap-x-2">
                  <p className="text-lg">{userRank === 1 ? '🥇' : userRank === 2 ? '🥈' : '🥉'}</p>
                  <p
                    className={cn({
                      'text-ss-accent-400': userRank === 1,
                      'text-ss-primary': userRank === 2,
                      'text-ss-azure-blue': userRank === 3,
                    })}
                  >
                    {nickname} {totalPoints} SSP
                  </p>
                  {userRank !== 3 && <p className="text-lg">-</p>}
                </div>
              ))
            ) : null
          ) : (
            <Skeleton className="w-36 rounded-lg">
              <div className="h-6 rounded-lg bg-default-200" />
            </Skeleton>
          )}
        </TitleMarquee>
      </div>
      <div className="mb-4 xl:hidden">
        <div className="px-6">
          <ExperienceSidebar />
        </div>
      </div>

      <div className={styles.componentFeed}>
        <div>
          <div className={styles.tab__switch__feeds0}>
            <TabSlider
              isCenter
              activeTab={activeTab}
              setActiveTab={(value) => {
                setActiveTab(value)
                if (getParamsShareId) {
                  const params = new URLSearchParams(searchParams)
                  params.delete('shareID')
                  router.replace(`${pathname}?${params.toString()}`, { scroll: false })
                }
              }}
              tabs={tabs}
              className="mx-auto"
            />
          </div>

          <div className="  border-b border-white/10 pb-4  ">
            <div className="px-6">
              <PostTextarea />
            </div>
          </div>

          {activeTab === 0 && <ListPost key={'all'} />}
          {activeTab === 1 && <ListTrending key={'trending'} />}
          {activeTab === 2 && <ListFollowing key={'following'} />}
        </div>
      </div>
      {/* <BackTopTop /> */}
      <PostAddMB />
    </ClientOnly>
  )
}

export default FeedPage
